import RootScreen from "./screens/Root/Root.Screen";
import React, {Component} from 'react'

export default class App extends Component {
  render() {
    return (<RootScreen/>)
  }
}
